import { remove as removeWaitlistEntry } from "api/waitlist";

export default async function removeCustomer({
  businessUid,
  entry,
  reason,
  served,
}) {
  // Don't log visits to the visits log
  const { visits, uid, ...others } = entry;

  try {
    await removeWaitlistEntry(businessUid, uid);
  } catch (error) {
    throw new Error("Couldn't delete Entry from waitlist");
  }
}
